/** Contact & social — aligned with cwy-landing locales/en Contact + Footer */
export const FOOTER_CONTACT = {
  phone: '+1 (647) 829-8643',
  email: 'info@canadawaleyar.com',
  linkedin: 'https://www.linkedin.com/company/107795571',
  instagram: 'https://instagram.com/canadawale_yar',
  whatsapp: '16478298643',
} as const;

export const FOOTER_APP_STORE_LINKS = {
  ios: 'https://apps.apple.com/ca/app/canadawale-yar/id6752109391',
  android: 'https://play.google.com/store/apps/details?id=com.cwy.app&pcampaignid=web_share',
} as const;

export const FOOTER_BRAND = {
  headline: 'Connect with trusted professionals',
  subheadline: 'One platform. All essential services.',
} as const;
